export default "/images/vendor/flag-icons/flags/4x3/us.svg?bbbd9f5266841b5c49cc50c7be63ae09";